// extracted by mini-css-extract-plugin
export default {"container":"TeamInvitation_container__cvaVg","centered":"TeamInvitation_centered__m15RH"};